export default __webpack_public_path__ + "static/media/GooglecertifiedImage.da413cf0.png";